import { render, staticRenderFns } from "./MarketingMailRecord.vue?vue&type=template&id=112e44f9&scoped=true&"
import script from "./MarketingMailRecord.vue?vue&type=script&lang=js&"
export * from "./MarketingMailRecord.vue?vue&type=script&lang=js&"
import style0 from "./MarketingMailRecord.vue?vue&type=style&index=0&id=112e44f9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112e44f9",
  null
  
)

export default component.exports